// Module-level flag injected into axios requests as `investor_view=true`
// while the investor view of a listing is mounted. Lets the backend hide
// unpaid-reservation financials independently of the viewer's role, so an
// admin who opens the investor view sees what the investor sees.
let investorViewActive = 0

export const setInvestorView = active => {
  investorViewActive = Math.max(0, investorViewActive + (active ? 1 : -1))
}

export const isInvestorView = () => investorViewActive > 0
